import { defineMessages } from "react-intl";

export const messages = defineMessages({
  showOnlyMasterLines: {
    id: "ari.management.sortAndFilter.showOnlyMasterLines",
    defaultMessage: "Show only master lines",
  },
});
